import React, {Component} from 'react'
import {
    Form,
    FormGroup,
    Label,
    Button,
    Input,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter
} from 'reactstrap'
import {
    AvForm,
    AvField
} from 'availity-reactstrap-validation'
import PropTypes from 'prop-types'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {Mutation} from 'react-apollo'
import {withRouter} from 'react-router-dom'

import upsertClientMutation from '../../../queries/server/mutations/upsert_client'
import AUSelectGenerator from '../../components/auto_updaters/ValidSelect'

const AUSelectClientTypes = AUSelectGenerator('client_types', 'client_type_id description', 'client_type_id', ['description'])

class ClientCreateModal extends Component {

    state = {
        name: '',
        client_type_id: '',
        invoice_prefix: '',
        is_supplier: false
    }

    constructor(props) {
        super(props)
        this.form = null
    }

    render() {

        const {isOpen, toggle} = this.props
        const {name, client_type_id, invoice_prefix, is_supplier} = this.state

        return (
            <Mutation mutation={upsertClientMutation}>
                {(upsertClientMutationFunc, {loading}) => (

                    <Modal isOpen={isOpen}>
                        <AvForm ref={ref => this.form = ref}
                                onValidSubmit={(event, errors, values) => {
                                    upsertClientMutationFunc({
                                        variables: {
                                            data: {
                                                name,
                                                client_type_id,
                                                invoice_prefix,
                                                is_supplier
                                            }
                                        }
                                    })
                                        .then(({data}) => {
                                            this.props.history.push(`/clients/${data.upsertClient.client_id}`)
                                        })
                                }}
                                >
                            <ModalHeader toggle={toggle}>
                                Create Client
                            </ModalHeader>
                            <ModalBody>
                                <AvField
                                    label="Client Name*"
                                    name="name"
                                    id="name"
                                    bsSize="sm"
                                    required
                                    errorMessage="Required"
                                    value={name}
                                    onChange={(evt) => {
                                        console.log('form', this.form)
                                        this.setState({name: evt.target.value})
                                    }}
                                />
                                <AUSelectClientTypes
                                    required
                                    errorMessage="Required"
                                    label="Client Type*"
                                    name="client_type_id"
                                    bsSize="sm"
                                    value={client_type_id}
                                    onChange={(client_type_id) => this.setState({client_type_id})}
                                />

                                <AvField
                                    label="Invoice Prefix*"
                                    name="invoice_prefix"
                                    id="invoice_prefix"
                                    bsSize="sm"
                                    required
                                    errorMessage="Required"
                                    value={invoice_prefix}
                                    onChange={(evt) => {
                                        console.log('form', this.form)
                                        this.setState({invoice_prefix: evt.target.value})
                                    }}
                                />

                                <AvField
                                    label="Is Supplier"
                                    type="checkbox"
                                    name="is_supplier"
                                    id="is_supplier"
                                    value={is_supplier}
                                    onChange={(evt) => {
                                        this.setState({is_supplier: evt.target.checked})
                                    }}
                                />


                            </ModalBody>
                            <ModalFooter>
                                <Button size="sm" color="success" disabled={loading}>
                                    <FontAwesomeIcon
                                        color="#fff"
                                        icon={loading ? 'spinner' : 'save'}
                                        spin={loading}
                                    />{' '}
                                    {loading ? 'Saving...' : 'Save'}
                                </Button>
                            </ModalFooter>
                        </AvForm>
                    </Modal>

                )}

            </Mutation>
        )
    }

}

ClientCreateModal = withRouter(ClientCreateModal)

export default ClientCreateModal

ClientCreateModal.propTypes = {
    isOpen: PropTypes.bool,
    toggle: PropTypes.func
}